import { Component, OnDestroy, OnInit } from '@angular/core';
import { LanguageService } from '@spartacus/core';
import { map, Observable, Subject, Subscription, takeUntil } from 'rxjs';
import { GetDocumentService } from 'src/app/customServices/get-document.service';
import { CustomerIdService } from 'src/app/services/feature/customerId/customer-id.service';

@Component({
  selector: 'app-core-report',
  templateUrl: './core-report.component.html',
  styleUrl: './core-report.component.scss',
  standalone: false
})
export class CoreReportComponent implements OnInit {

  latestDocUrl$: Observable<string>;
  activeLanguage$!: Observable<string>;
  userData$!: Observable<any>;
  subscription = new Subscription();
  constructor(private documentService: GetDocumentService,
    private languageService: LanguageService,
    public custIDService: CustomerIdService,
  ) {

  }
  ngOnInit() {

    this.activeLanguage$ = this.languageService.getActive();

    this.userData$ = this.custIDService.getAllCustomerId().pipe(
      map((apiResponse: any) => apiResponse?.userWS)
    );

    this.latestDocUrl$ = this.documentService
      .getDocumentByDocumentCode('BW7626')
      .pipe(map((response: { url: string }) => response.url));
  }
  ngOnDestroy(): void {
    // Unsubscribe from the scroll event
    this.subscription.unsubscribe();
  }

}

